import App from 'App';
import { UserManagerProvider, APIProvider } from '@fregata/shared';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import 'moment/locale/zh-cn';

// fix：message 组件不生效的问题
ConfigProvider.config({
  prefixCls: 'cssc', // 4.13.0+
  iconPrefixCls: 'anticon', // 4.17.0+
});

const RootComponent = () => {
  return (
    <ConfigProvider locale={zhCN} prefixCls='cssc'>
      <UserManagerProvider
        value={{
          storeKey: 'csscii:',
          store: localStorage,
          apiBaseURL: CONFIG.API_BASE_URL,
          refreshUserInfoURL: `/api/app-site/index/current_user_info`,
          // loginURL
          // refreshAccessTokenURL: '',
        }}
      >
        <APIProvider defaultConfig={{}}>
          <App />
        </APIProvider>
      </UserManagerProvider>
    </ConfigProvider>
  );
};

export default RootComponent;
